import React from "react";
import {
  GeneralSoProvider,
} from "./generalSo.context";
import { LoaderProvider } from "./loader.context";
import { CalculationProvider } from "./calculationInput.context";
import { GlobalLoader } from "src/components/other/globalLoader.other";

export const Provider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <LoaderProvider>
      <GeneralSoProvider>
        <CalculationProvider>
          {children}
        </CalculationProvider>
        <GlobalLoader />
      </GeneralSoProvider>
    </LoaderProvider>
  );
};
